var _path, _circle, _path2, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecycleIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 131 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119 59.5C119 92.3609 92.3609 119 59.5 119C26.6391 119 0 92.3609 0 59.5C0 26.6391 26.6391 0 59.5 0C92.3609 0 119 26.6391 119 59.5Z",
    fill: "#CCF5CF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 59.5,
    r: 51,
    stroke: "#37B159",
    strokeDasharray: "5 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8824 61.075V43.12C82.8824 37.8275 82.8824 35.1813 81.8629 33.1598C80.9662 31.3817 79.5354 29.936 77.7756 29.03C75.7749 28 73.1558 28 67.9176 28H47.9647C42.7266 28 40.1075 28 38.1068 29.03C36.3469 29.936 34.9161 31.3817 34.0194 33.1598C33 35.1813 33 37.8275 33 43.12V75.88C33 81.1725 33 83.8187 34.0194 85.8402C34.9161 87.6183 36.3469 89.064 38.1068 89.97C40.1075 91 42.7266 91 47.9647 91H57.9412M64.1765 56.35H45.4706M51.7059 68.95H45.4706M70.4118 43.75H45.4706M65.7353 81.55L71.9706 87.85L86 73.675",
    stroke: "#333333",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.5,
    cy: 27.5,
    r: 27.5,
    fill: "#13B71F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.25 30.8579C91.9358 31.8788 90.5 33.3015 90.5 34.875C90.5 37.9816 96.0964 40.5 103 40.5C109.904 40.5 115.5 37.9816 115.5 34.875C115.5 33.3015 114.064 31.8788 111.75 30.8579M110.5 23C110.5 28.0796 104.875 30.5 103 34.25C101.125 30.5 95.5 28.0796 95.5 23C95.5 18.8579 98.8579 15.5 103 15.5C107.142 15.5 110.5 18.8579 110.5 23ZM104.25 23C104.25 23.6904 103.69 24.25 103 24.25C102.31 24.25 101.75 23.6904 101.75 23C101.75 22.3096 102.31 21.75 103 21.75C103.69 21.75 104.25 22.3096 104.25 23Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycleIcon1);
export default __webpack_public_path__ + "static/media/recycle-icon1.9abde6b28bed5ca45690db19c0ca1f85.svg";
export { ForwardRef as ReactComponent };